import React from 'react';
import { Button as ButtonDaisyUI, type ButtonProps } from 'react-daisyui';

const Button = ({ className, children, ...props }: ButtonProps) => (
    <ButtonDaisyUI color="primary" className={`border-0 outline-none text-white p-2 cursor-pointer ${className}`} type="button" {...props}>
        {children}
    </ButtonDaisyUI>
);

export default Button;
